import { Box } from '@mantine/core';
import { useGetColor } from 'hooks';
import type { IconPropsType } from './types';

export const KeyIcon = ({ color, size = 24, sx, ...props }: IconPropsType) => {
  const iconColor = useGetColor(color);
  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="-2 -2 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 17L10.1429 7.85714M3.28571 14.7143L5.57143 17M5.57143 12.4286L7.85714 14.7143M13 9C10.7909 9 9 7.20914 9 5C9 2.79086 10.7909 1 13 1C15.2091 1 17 2.79086 17 5C17 7.20914 15.2091 9 13 9Z"
        stroke={iconColor}
        strokeWidth={1.5}
      />
    </Box>
  );
};
